import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import expertDefault from "../images/default.png"
import { Link } from "react-router-dom";
import $ from 'jquery';
import { database, modeOfLearningRef } from '../firebase'
import photography from "../images/photography.jpg"
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import StarRatings from 'react-star-ratings';
export default class Dashboard extends Component {
  constructor(props) {
    super(props)

    this.state = {
      userData: [],
      careerData: [],
      careerData1: [],
      careerData2: [],
      careerData3: [],
      guidanceArray: [],
      skillData: [],
      modeOfLearningData: [],
      institutionData: [],
      universityName: "",
      CourseName: "",
      imageUrl: "",
      Courserating: 0,
      Expertise: "",
      Language: '',
      Level: '',
      Modeoflearning: '',
      courseDescription: '',
      currentSalary: 0,
      salaryMax: 0,
      salaryMin: 0,
      salaryDifference: 0,
      ivanooograde: '',
      price: '',
      duration: '',
      progressInfo: "",
      accrediation: "",
      outcome: []
    }
    this.logout = this.logout.bind(this);
  }
  logout() {
    localStorage.removeItem("userId");
    localStorage.removeItem("userName");
    localStorage.removeItem("userImage");
    localStorage.removeItem("guidanceArray");
    window.location.href = "/"
  }
  async componentDidMount() {
    let userKey = localStorage.getItem("userId");
    let userName = localStorage.getItem("userName");
    this.setState({
      userName: userName
    })
    this.renderList(userKey)
    await this.renderModeOfLearning();
    await this.renderInstitute();
    await this.renderCourse();

    //await this.getGuidanceDetails(userKey)
    $("#activeCourse").click(function () {

      $(this).toggleClass("fa-bookmark");
      $(this).toggleClass("fa-bookmark-o");
    });
  }
  async getGuidanceDetails(keyId, careerDatas) {
    //console.log("inside getGuidanceDetails")
    let modeOfLearning = '';
    let budgetConstriction = '';
    let Expertise = ''
    let Skills = ''
    let goals = ''
    let country = ""
    let currentSalary = 0
    let SkillQuotient = 0
    let progressInfo = 0
    let newCourse = []
    let newCourse1 = []
    let newCourse2 = []
    let newCourse3 = []
    let skillCheckedData = []
    let experience = ""
    await database.ref("Guidance").once('value', function (snapshot) {
      snapshot.forEach(function (ChildSnapshot) {
        if (ChildSnapshot.val().hasOwnProperty('userDate')) {
          if (ChildSnapshot.val().userDate.hasOwnProperty('userId')) {
            if (ChildSnapshot.val().userDate.userId === keyId) {
              $("#Guidance").val(ChildSnapshot.key);
              localStorage.setItem("guidanceArray", JSON.stringify(ChildSnapshot.val()))
              modeOfLearning = ChildSnapshot.val().modeOfLearning
              budgetConstriction = ChildSnapshot.val().budgetConstriction
              goals = ChildSnapshot.val().goals
              country = ChildSnapshot.val().userDate.country
              Expertise = ChildSnapshot.val().Expertise
              Skills = ChildSnapshot.val().skillUserRating
              currentSalary = ChildSnapshot.val().currentSalary
              if (currentSalary === "") {
                currentSalary = 0
              }
              skillCheckedData = Skills.filter(el => el.skillChecked.includes("true"));
              $("#progressInfo").text(ChildSnapshot.val().progressInfo)
              progressInfo = ChildSnapshot.val().progressInfo
              if (ChildSnapshot.val().Experience != "") {
                SkillQuotient = SkillQuotient + 20
              }
              experience = ChildSnapshot.val().Experience
              let a = ChildSnapshot.val().skillUserRating
              let skillRating = 0
              if (a) {
                a.forEach((d) => {
                  skillRating = skillRating + parseInt(d.skillRating)
                });
                skillRating = skillRating / a.length;
              }
              let rate = 0
              rate = (skillRating <= 3) ? 10 : (skillRating <= 7) ? 20 : 30
              SkillQuotient = SkillQuotient + rate
              rate = (progressInfo <= 50) ? 10 : 20
              SkillQuotient = SkillQuotient + rate
              $("#skillquotient").text(SkillQuotient / 10);
              let careerData = careerDatas
              careerData.forEach(function (data) {
                if (data.hasOwnProperty('expertise')) {
                  if (data.expertise === Expertise) {
                    if (data.hasOwnProperty('CourseFields')) {
                      if (data.CourseFields != undefined) {
                        if (data.CourseFields[0].hasOwnProperty('CourseScore')) {
                          let score = data.CourseFields[0].CourseScore
                          if (score) {
                            if (goals == 4 || goals == 7 || goals == 10 || goals == 14 || goals == 18) {
                              if (data.hasOwnProperty('Country')) {
                                if (data.Country == country) {
                                  newCourse.push(data)
                                }
                              }
                            }
                            else if (goals == 3 || goals == 6 || goals == 9 || goals == 13 || goals == 17) {

                              if (data.hasOwnProperty('CourseFields')) {
                                if (data.CourseFields[0].QuickUpskilling != undefined) {
                                  newCourse.push(data)
                                }
                              }
                            }
                            else {
                              newCourse.push(data)
                            }
                            // if (goals == "I want to upskill myself quickly.") {
                            //   if (data.hasOwnProperty('outcomes')) {
                            //     if (data.outcomes[0].QuickUpskills == "True") {
                            //       newCourse.push(data)
                            //     }
                            //     //console.log("inside 1....")
                            //   }
                            // }
                            // if (goals == "I'm looking for a certificate") {
                            //   //console.log("123....", data.hasOwnProperty('outcomes'))
                            //   if (data.hasOwnProperty('outcomes')) {
                            //     if (data.outcomes[0].Certificates == "True") {
                            //       newCourse.push(data)
                            //     }
                            //     //console.log("inside 2....")
                            //   }
                            // }
                            // if (goals == "I'm looking for a skill-set to get a job.") {
                            //   if (data.hasOwnProperty('outcomes')) {
                            //     if (data.outcomes[0].Jobs == "True") {
                            //       newCourse.push(data)
                            //     }
                            //     //console.log("inside 3....")
                            //   }
                            // }
                            // if (goals == 'I want to transit in a new career') {
                            //   if (data.hasOwnProperty('outcomes')) {
                            //     if (data.outcomes[0].CareerTransition == "True") {
                            //       newCourse.push(data)
                            //     }
                            //     //console.log("inside 4....")
                            //   }
                            // }

                            //Sort by ivanoscore
                            if (goals == 4 || goals == 7 || goals == 10 || goals == 14 || goals == 18) {
                              newCourse.sort(function (a, b) {
                                var keyA = a.CourseFields[0].CourseScore,
                                  keyB = b.CourseFields[0].CourseScore;
                                if (parseFloat(keyA) < parseFloat(keyB)) return -1;
                                if (parseFloat(keyA) > parseFloat(keyB)) return 1;
                                return 0;
                              });
                              newCourse = newCourse.reverse()
                            }
                            //Sort by Certificate
                            if (goals == 2 || goals == 5 || goals == 8 || goals == 12) {
                              //console.log("inside Certificate")
                              newCourse.sort(function (x, y) {
                                var n = parseFloat(x.CourseFields[0].Ranking) - parseFloat(y.CourseFields[0].Ranking);
                                if (n !== 0) {
                                  return n;
                                }
                                return parseFloat(x.CourseFields[0].CourseScore) - parseFloat(y.CourseFields[0].CourseScore);
                              })
                              newCourse.reverse()
                            }
                            //Sort by Job Assistance
                            if (goals == 1 || goals == 11 || goals == 15) {
                              //console.log("inside Job Assistance")
                              newCourse.sort(function (x, y) {
                                var n = parseFloat(x.CourseFields[0].JobAssistance) - parseFloat(y.CourseFields[0].JobAssistance);
                                if (n !== 0) {
                                  return n;
                                }
                                return parseFloat(x.CourseFields[0].CourseScore) - parseFloat(y.CourseFields[0].CourseScore);
                              })
                              newCourse.reverse()
                            }
                            //Sort by Quick Upskilling
                            if (goals == 3 || goals == 6 || goals == 9 || goals == 13 || goals == 17) {
                              //console.log("inside Quick Upskilling")
                              newCourse.sort(function (x, y) {
                                var n = parseFloat(x.CourseFields[0].QuickUpskilling) - parseFloat(y.CourseFields[0].QuickUpskilling);
                                if (n !== 0) {
                                  return n;
                                }
                                return parseFloat(x.CourseFields[0].CourseScore) - parseFloat(y.CourseFields[0].CourseScore);
                              })
                              newCourse.reverse()

                            }
                            //console.log("newCourse...", newCourse)
                            // if (goals == "I want to learn a new skill") {
                            //   if (data.hasOwnProperty('outcomes')) {
                            //     if (data.outcomes.length == 2) {
                            //       newCourse.sort(function (a, b) {
                            //         var keyA = a.outcomes[1].QuickUpskillsScore,
                            //           keyB = b.outcomes[1].QuickUpskillsScore;
                            //         if (keyA < keyB) return -1;
                            //         if (keyA > keyB) return 1;
                            //         return 0;
                            //       });
                            //       newCourse = newCourse.reverse()
                            //     }
                            //   }
                            // }
                            // if (goals == "I want to upskill myself quickly.") {
                            //   if (data.hasOwnProperty('outcomes')) {
                            //     if (data.outcomes.length == 2) {
                            //       newCourse.sort(function (a, b) {
                            //         var keyA = a.outcomes[1].QuickUpskillsScore,
                            //           keyB = b.outcomes[1].QuickUpskillsScore;
                            //         if (keyA < keyB) return -1;
                            //         if (keyA > keyB) return 1;
                            //         return 0;
                            //       });
                            //       newCourse = newCourse.reverse()
                            //     }
                            //   }
                            // }
                            // if (goals == "I'm looking for a certificate") {
                            //   if (data.hasOwnProperty('outcomes')) {
                            //     if (data.outcomes.length == 2) {
                            //       newCourse.sort(function (a, b) {
                            //         var keyA = a.outcomes[1].CertificatesScore,
                            //           keyB = b.outcomes[1].CertificatesScore;
                            //         if (keyA < keyB) return -1;
                            //         if (keyA > keyB) return 1;
                            //         return 0;
                            //       });
                            //       newCourse = newCourse.reverse()
                            //     }
                            //   }
                            // }
                            // if (goals == "I'm looking for a skill-set to get a job.") {
                            //   if (data.hasOwnProperty('outcomes')) {
                            //     if (data.outcomes.length == 2) {
                            //       newCourse.sort(function (a, b) {
                            //         var keyA = a.outcomes[1].JobsScore,
                            //           keyB = b.outcomes[1].JobsScore;
                            //         if (keyA < keyB) return -1;
                            //         if (keyA > keyB) return 1;
                            //         return 0;
                            //       });
                            //       newCourse = newCourse.reverse()
                            //     }
                            //   }
                            // }
                            // if (goals == "I want to transit in a new career") {
                            //   if (data.hasOwnProperty('outcomes')) {
                            //     if (data.outcomes.length == 2) {
                            //       newCourse.sort(function (a, b) {
                            //         var keyA = a.outcomes[1].CareerTransitionScore,
                            //           keyB = b.outcomes[1].CareerTransitionScore;
                            //         if (keyA < keyB) return -1;
                            //         if (keyA > keyB) return 1;
                            //         return 0;
                            //       });
                            //       newCourse = newCourse.reverse()
                            //     }
                            //   }
                            // }
                            if (skillCheckedData.length > 0) {
                              if (data.hasOwnProperty('Skills')) {
                                if (data.Skills != undefined) {
                                  if (skillCheckedData.length == 1) {
                                    const skillCheckedData1 = data.Skills.filter(el => el.skill.includes(skillCheckedData[0].skillName));
                                    if (skillCheckedData1.length > 0) {
                                      newCourse1.push(data)
                                    }
                                  }
                                  if (skillCheckedData.length == 2) {
                                    const skillCheckedData1 = data.Skills.filter(el => el.skill.includes(skillCheckedData[0].skillName));
                                    const skillCheckedData2 = data.Skills.filter(el => el.skill.includes(skillCheckedData[1].skillName));
                                    if (skillCheckedData1.length > 0) {
                                      newCourse1.push(data)
                                    }
                                    if (skillCheckedData2.length > 0) {
                                      newCourse2.push(data)
                                    }
                                  }
                                  if (skillCheckedData.length >= 3) {
                                    const skillCheckedData1 = data.Skills.filter(el => el.skill.includes(skillCheckedData[0].skillName));
                                    const skillCheckedData2 = data.Skills.filter(el => el.skill.includes(skillCheckedData[1].skillName));
                                    const skillCheckedData3 = data.Skills.filter(el => el.skill.includes(skillCheckedData[2].skillName));
                                    if (skillCheckedData1.length > 0) {
                                      newCourse1.push(data)
                                    }
                                    if (skillCheckedData2.length > 0) {
                                      newCourse2.push(data)
                                    }
                                    if (skillCheckedData3.length > 0) {
                                      newCourse3.push(data)
                                    }
                                  }
                                }
                                else {
                                  if (skillCheckedData.length == 1) {
                                    if (data.CourseName.includes(skillCheckedData[0].skillName)) {
                                      newCourse1.push(data)
                                    }
                                  }
                                  if (skillCheckedData.length == 2) {
                                    if (data.CourseName.includes(skillCheckedData[1].skillName)) {
                                      newCourse2.push(data)
                                    }
                                    if (data.CourseName.includes(skillCheckedData[0].skillName)) {
                                      newCourse1.push(data)
                                    }
                                  }
                                  if (skillCheckedData.length == 3) {
                                    if (data.CourseName.includes(skillCheckedData[1].skillName)) {
                                      newCourse2.push(data)
                                    }
                                    if (data.CourseName.includes(skillCheckedData[0].skillName)) {
                                      newCourse1.push(data)
                                    }
                                    if (data.CourseName.includes(skillCheckedData[2].skillName)) {
                                      newCourse3.push(data)
                                    }
                                  }
                                }
                                if (newCourse1.length > 0 || newCourse2.length > 0 || newCourse3.length > 0) {
                                  newCourse = []
                                }
                              }
                            }
                            //console.log("newCourse123...", newCourse)
                          }
                        }
                      }
                    }
                  }
                }

              });
            }
          }
        }
      }
      )
    })
    //console.log("0.....", newCourse)
    if (newCourse1.length > 0) {
      var newCourse1Arr = []

      newCourse1.sort(function (a, b) {
        var keyA = a.CourseFields[0].CourseScore,
          keyB = b.CourseFields[0].CourseScore;
        if (parseFloat(keyA) < parseFloat(keyB)) return -1;
        if (parseFloat(keyA) > parseFloat(keyB)) return 1;
        return 0;
      });
      newCourse1 = newCourse1.reverse()

      // newCourse1.forEach(function (data) {
      //   data.Skills.forEach(function (data1) {
      //     if (data1.hasOwnProperty("skillRating") && data1.skill == skillCheckedData[0].skillName) {
      //       data.skillRating = data1.skillRating
      //       newCourse1Arr.push(data)
      //     }
      //     else {
      //       data.skillRating = 0
      //       newCourse1Arr.push(data)
      //     }
      //   });
      // });
      // newCourse1 = newCourse1Arr
      // newCourse1.sort(function (a, b) {
      //   var keyA = a.skillRating,
      //     keyB = b.skillRating;
      //   if (keyA < keyB) return -1;
      //   if (keyA > keyB) return 1;
      //   return 0;
      // });
      // var newCourse1Arr1 = newCourse1.filter(el => el.skillRating > 0);
      // if (newCourse1Arr1.length > 0) {
      //   newCourse1.reverse()
      // }
    }
    //console.log("1.....", newCourse)
    if (newCourse2.length > 0) {
      newCourse2.sort(function (a, b) {
        var keyA = a.CourseFields[0].CourseScore,
          keyB = b.CourseFields[0].CourseScore;
        if (parseFloat(keyA) < parseFloat(keyB)) return -1;
        if (parseFloat(keyA) > parseFloat(keyB)) return 1;
        return 0;
      });
      newCourse2 = newCourse2.reverse()

      // var newCourse2Arr = []
      // newCourse2.forEach(function (data) {
      //   data.Skills.forEach(function (data1) {
      //     if (data1.hasOwnProperty("skillRating") && data1.skill == skillCheckedData[1].skillName) {
      //       data.skillRating = data1.skillRating
      //       newCourse2Arr.push(data)
      //     }
      //     else {
      //       data.skillRating = 0
      //       newCourse2Arr.push(data)
      //     }
      //   });
      // });
      // newCourse2 = newCourse2Arr
      // newCourse2.sort(function (a, b) {
      //   var keyA = a.skillRating,
      //     keyB = b.skillRating;
      //   if (keyA < keyB) return -1;
      //   if (keyA > keyB) return 1;
      //   return 0;
      // });
      // var newCourse2Arr1 = newCourse2.filter(el => el.skillRating > 0);
      // //console.log("newCourse2...",newCourse2Arr1)
      // if (newCourse2Arr1.length > 0) {
      //   newCourse2.reverse()
      // }
    }
    if (newCourse3.length > 0) {
      newCourse3.sort(function (a, b) {
        var keyA = a.CourseFields[0].CourseScore,
          keyB = b.CourseFields[0].CourseScore;
        if (parseFloat(keyA) < parseFloat(keyB)) return -1;
        if (parseFloat(keyA) > parseFloat(keyB)) return 1;
        return 0;
      });
      newCourse3 = newCourse3.reverse()

      // var newCourse3Arr = []
      // newCourse3.forEach(function (data) {
      //   data.Skills.forEach(function (data1) {
      //     if (data1.hasOwnProperty("skillRating") && data1.skill == skillCheckedData[2].skillName) {
      //       data.skillRating = data1.skillRating
      //       newCourse3Arr.push(data)
      //     }
      //     else {
      //       data.skillRating = 0
      //       newCourse3Arr.push(data)
      //     }
      //   });
      // });
      // newCourse3 = newCourse3Arr
      // newCourse3.sort(function (a, b) {
      //   var keyA = a.skillRating,
      //     keyB = b.skillRating;
      //   if (keyA < keyB) return -1;
      //   if (keyA > keyB) return 1;
      //   return 0;
      // });
      // var newCourse3Arr1 = newCourse2.filter(el => el.skillRating > 0);
      // if (newCourse3Arr1.length > 0) {
      //   newCourse3.reverse()
      // }
    }
    let salaryMax = 0
    let salaryMin = 0
    let salaryDifference = 0
    await database.ref("expertise").once('value', function (snapshot) {
      snapshot.forEach(function (ChildSnapshot) {
        if (ChildSnapshot.val().expertise === Expertise) {
          //console.log("4.....", ChildSnapshot.val().experienceSalaryDetails)
          if (ChildSnapshot.val().hasOwnProperty('experienceSalaryDetails')) {
            const salaryData = ChildSnapshot.val().experienceSalaryDetails.filter(el => el.experience.includes(experience));
            //console.log("5.....", newCourse)
            salaryMin = salaryData[0].salaryMin
            salaryMax = salaryData[0].salaryMax
            //console.log("salaryMax...",salaryMax)
            salaryDifference = parseFloat(salaryMax) - parseFloat(currentSalary)
          }
        }
      })
    })
    this.setState({ careerData: this.getUnique(newCourse, 'key'), careerData1: this.getUnique(newCourse1, 'key'), careerData2: this.getUnique(newCourse2, 'key'), careerData3: this.getUnique(newCourse3, 'key'), Expertise: Expertise, progressInfo: progressInfo, currentSalary: currentSalary, salaryMin: salaryMin, salaryMax: salaryMax, salaryDifference: salaryDifference, skillData: skillCheckedData })
    //Commented 10/10/2022 Starts for new algorithm
    // budgetConstriction = budgetConstriction.split('-');
    // let budget1 = parseFloat(budgetConstriction[0])
    // let budget2 = parseFloat(budgetConstriction[1])
    // if (Skills.length > 0) {
    //   Skills = Skills.filter(function (el) {
    //     return el.skillRating > 0
    //   }
    //   );
    //   console.log("Skills1...", Skills)
    // }
    //Commented 10/10/2022 End
    //careerData.forEach(function (data) {
    // console.log("data1.....",data)
    // console.log("Expertise1.....",data.Expertise)
    // if(data.Expertise.includes(Expertise)){
    //   newCourse.push(data)
    // }
    //Commented 10/10/2022 Starts
    // if (data.price != "" && data.price != "Free") {
    //   let price = data.price
    //   price = price.replace("$", '').replace(" ", '')
    //   price = parseFloat(price)
    //   if (data.Modeoflearning.includes(modeOfLearning) && (price > budget1 && price < budget2)) {
    //     newCourse.push(data)
    //   }
    // }
    // else {
    //   if (data.Modeoflearning.includes(modeOfLearning)) {
    //     newCourse.push(data)
    //   }
    // }
    //Commented 10/10/2022 End
    // let price = data.price
    // price = price.replace("$", '').replace(" ", '')
    // price = parseFloat(price)

    // if(price>budget1 && price < budget2) {
    //   newCourse.push(data)  
    // } 
    // if(data.Accrediation.includes(Expertise)){
    //   newCourse.push(data)  
    // }

    //});
  }
  getUnique(array, key) {
    if (typeof key !== 'function') {
      const property = key;
      key = function (item) { return item[property]; };
    }
    return Array.from(array.reduce(function (map, item) {
      const k = key(item);
      if (!map.has(k)) map.set(k, item);
      return map;
    }, new Map()).values());
  }
  async renderList(keyId) {
    let id = keyId;
    const ref = id ? '/SecUser/' + id : 'SecUser'
    const userRef = database.ref(ref)
    const valueRef = id ? userRef : await userRef.orderByChild('key').equalTo('value')
    const snapshot = await valueRef.once('value')
    const val = snapshot.val()
    if (val) {
      let data = val;
      // localStorage.setItem("userId",data.userDate.userId)
      // localStorage.setItem("userFullName",data.userDate.fullName)
      // localStorage.setItem("userImage",val.imageUrl)
      this.setState({
        userData: val,
        userFullName: data.fullName,
        userImage: data.imageUrl
      })
    }
  }
  async renderModeOfLearning() {

    let dataList = [];
    await database.ref("modeOfLearning").once('value', function (snapshot) {
      snapshot.forEach(
        function (ChildSnapshot) {
          dataList.push({
            key: ChildSnapshot.key,
            modeOfLearning: ChildSnapshot.val().modeOfLearning,
            modeOfLearningStatus: ChildSnapshot.val().status,
            internalId: ChildSnapshot.val().internalId
          })
        }
      )
    })
    this.setState({
      modeOfLearningData: dataList
    })
  }
  async renderInstitute() {

    let dataList = [];
    await database.ref("institution").once('value', function (snapshot) {
      snapshot.forEach(
        function (ChildSnapshot) {
          dataList.push({
            key: ChildSnapshot.key,
            institution: ChildSnapshot.val().institution,
            institutionStatus: ChildSnapshot.val().status,
            internalId: ChildSnapshot.val().internalId
          })
        }
      )
    })
    this.setState({
      institutionData: dataList
    })
  }
  async renderCourse() {
    let dataList = [];
    let userKey = localStorage.getItem("userId");
    let modeOfLearningData = this.state.modeOfLearningData
    let institutionData = this.state.institutionData
    await database.ref("Course").once('value', function (snapshot) {
      snapshot.forEach(
        function (ChildSnapshot) {
          let mode = ""
          let modeOfLearning = modeOfLearningData.filter(e => e.internalId.toString() === ChildSnapshot.val().Modeoflearning.toString())
          if (modeOfLearning.length > 0) {
            mode = modeOfLearning[0].modeOfLearning
          }
          let university = ""
          let universityVal = institutionData.filter(e => e.internalId.toString() === ChildSnapshot.val().universityName.toString())
          if (universityVal.length > 0) {
            university = universityVal[0].institution
          }
          dataList.push({
            key: ChildSnapshot.key, CourseName: ChildSnapshot.val().CourseName,
            imageUrl: ChildSnapshot.val().imageUrl,
            universityName: university,
            Courserating: ChildSnapshot.val().Courserating,
            Country: ChildSnapshot.val().Country != undefined ? ChildSnapshot.val().Country : "",
            Language: ChildSnapshot.val().Language,
            Level: ChildSnapshot.val().Level,
            Accrediation: ChildSnapshot.val().Accrediation,
            CourseFields: ChildSnapshot.val().CourseFields,
            outcomes: ChildSnapshot.val().outcomes,
            expertise: ChildSnapshot.val().expertise,
            Skills: ChildSnapshot.val().skills,
            Modeoflearning: mode,
            courseDescription: ChildSnapshot.val().courseDescription,
            price: ChildSnapshot.val().whatyoudo_rightModel[0].modelData ? ChildSnapshot.val().whatyoudo_rightModel[0].modelData[0].price : "",
            duration: ChildSnapshot.val().whatyoudo_rightModel[0].modelData ? ChildSnapshot.val().whatyoudo_rightModel[0].modelData[0].duration : "",
          })
        }
      )
    })
    await Promise.all(this.getGuidanceDetails(userKey, dataList))
    //  this.setState({ careerData: dataList })
  }

  coursePopup(data) {
    //console.log("data.........", data)
    let ratingVal = 0
    //console.log("this.state.rating...", data.Courserating)
    if (data.Courserating) {
      ratingVal = data.Courserating
      //console.log("ratingVal1...", ratingVal)
      ratingVal = ratingVal.split('/')[0]
      //console.log("ratingVal2...", ratingVal)
    }
    this.setState({
      universityName: data.universityName,
      CourseName: data.CourseName,
      imageUrl: data.imageUrl,
      Language: data.Language,
      Level: data.Level,
      Modeoflearning: data.Modeoflearning,
      courseDescription: data.courseDescription,
      key: data.key,
      price: data.price,
      duration: data.duration,
      Courserating: parseFloat(ratingVal),
      ivanooograde: data.CourseFields[0].CourseScore,
      accrediation: data.Accrediation,
      outcome: data.outcomes[0]
    })
    $("body").addClass("modal-open");
    $("#coursePopup").addClass("show");
    $(".modal").show();
    $('.modal-backdrop').add();
    $('body').append('<div class="modal-backdrop fade show"></div>');
  }
  closePopup() {
    $("body").removeClass("modal-open");
    $(".modal").removeClass("show");
    $(".modal").hide();
    $('.modal-backdrop').remove();
  }
  gotoSteps() {
    let Guidance = $("#Guidance").val()
    window.location.href = "/assesment/personna/id=" + Guidance
  }

  render() {

    return (

      <div className="main-wrapper user-dashboard-wrapper">
        <Header ></Header>
        <div className="main-content">
          <div className="container">
            <div className='row'>
              <div className='col-md-4 col-lg-3 mt-4'>
                <div className="usr-dasbrd-menu">
                  <div className='usr-dasbrd-menuhead'>My Account</div>
                  <Link className="usr-dasbrd-menuList usr-dasbrd-menuAct" to="/user-dashboard">
                    Dashoboard
                  </Link>
                  <Link className="usr-dasbrd-menuList" onClick={() => this.gotoSteps()}>
                    Profile
                  </Link>
                  <Link className="usr-dasbrd-menuList" to="" onClick={this.logout}>
                    LogOut
                  </Link>
                </div>
              </div>
              <div className='col-md-8 col-lg-9 mt-4'>
                <div className="userdash-box-right">
                  <div className='row'>
                    <div className='col-md-7 col-lg-8 text-center mb-4'>
                      <div className='header-head-thin'>
                        <h4>Welcome, {this.state.userName}</h4>
                      </div>
                      <div className='userdash-box-img'>
                        {this.state.userImage ?
                          <img alt="" className="userdash-img" src={this.state.userImage} />
                          :
                          <img alt="" className="userdash-img" src={expertDefault} />
                        }
                      </div>
                      {/* <p className="userdash-box-text">Admin</p> */}
                    </div>
                    <div className='col-md-5 col-lg-4 text-center mb-4'>
                      <div className='usr-dash-progress'>
                        <p><spam id="progressInfo"></spam>% completed</p>
                        <input type="hidden" id="Guidance" />
                        <div className="progress">

                          <div className="progress-bar" role="progressbar" style={{ width: this.state.progressInfo + "%" }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </div>

                      <p className='progress-info'>
                        <a style={{ fontSize: "13px", color: "#0d6efd", cursor: "pointer" }}
                          onClick={() => this.gotoSteps()}
                        >Complete your profile</a>
                        {/* <a  style={{fontSize:"13px",color:"#0d6efd"}} href={'/assesment/apply-2/id=' + localStorage.getItem("userId")}>Complete your profile</a> */}
                      </p>
                    </div>
                    <div className='col-lg-9'>
                      {/* <div className='usr-dash-head'>Your Ivanooo skill quotient is <span id="skillquotient">0</span></div> */}
                      {/* <div className='usr-dash-subhead mb-2'>For the industry domain: {this.state.Expertise}</div> */}
                      {this.state.currentSalary > 0 ?
                        <div>
                          <div className='usr-dash-subhead mb-2'>Skill Quotient Analysis</div>
                          <div className='usr-dash-subhead mb-2'>You have a gap of $ {parseFloat(this.state.salaryDifference).toFixed(2)} as per your given salary, $ {parseFloat(this.state.currentSalary).toFixed(2)} in contrast to the average market range of $ {parseFloat(this.state.salaryMin).toFixed(2)} - $ {parseFloat(this.state.salaryMax).toFixed(2)}.
                            You can consider taking up the following courses to bridge that gap.

                            {/* As per our Skill Quotient analysis, your given salary is ($ {parseFloat(this.state.currentSalary).toFixed(2)}) in contrast to the market average range, which is ($ {parseFloat(this.state.salaryMin).toFixed(2)}- $ {parseFloat(this.state.salaryMax).toFixed(2)}). You have got a gap of $ {parseFloat(this.state.salaryDifference).toFixed(2)}. However, you can consider taking up the following courses, to increase your skill inventory as well as your earning potential. */}
                          </div>
                        </div>
                        : <div>
                          <div className='usr-dash-subhead mb-2'>Skill Quotient Analysis</div>
                          <div className='usr-dash-subhead mb-2'>Non-applicable (salary range is required to reach an analysis) </div></div>}
                      {/* <p className='usr-dash-p'>Which is good,considering tht global average ISQ is 7.6 </p> */}
                      <p className='usr-dash-p' style={{ color: "red" }}>Disclaimer: This segment is not applicable to the freshers as they do not have any exposure to working experience yet.</p>
                    </div>
                    {/* <div className='col-lg-3'>
                      <button className='btn btn-outline-primary btn-sm' style={{ borderColor: "#0d6efd" }}>Retake the aptitude test</button>
                    </div> */}

                    {/* <div className='col-md-12 mt-4'>
                      <p className='usr-dash-p'>Our algorithm also suggest you </p>
                      <p className='usr-dash-p mb-2'>the following domains as a carrier option: </p>
                      <a href="#" className="btn btn-default usr-dash-btn" style={{ borderColor: "#ccc", position: "relative" }}>
                        <span className='badge'>Average</span>
                        <p className="btn-top-name">For the Industry Domain:</p>
                        <p className="btn-top-designation"><strong>{"<Domain ABC>"}</strong></p>
                        <p className="btn-top-designation">ISQ: 5.6 / Global average: 12.7</p>
                      </a>
                      <a href="#" className="btn btn-default usr-dash-btn" style={{ borderColor: "#ccc", position: "relative" }}>
                        <span className='badge'>Average</span>
                        <p className="btn-top-name">For the Industry Domain:</p>
                        <p className="btn-top-designation"><strong>{"<Domain ABC>"}</strong></p>
                        <p className="btn-top-designation">ISQ: 5.6 / Global average: 12.7</p>
                      </a>
                      <a href="#" className="btn btn-default usr-dash-btn" style={{ borderColor: "#ccc", position: "relative" }}>
                        <span className='badge'>Average</span>
                        <p className="btn-top-name">For the Industry Domain:</p>
                        <p className="btn-top-designation"><strong>{"<Domain ABC>"}</strong></p>
                        <p className="btn-top-designation">ISQ: 5.6 / Global average: 12.7</p>
                      </a>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
            <div className='col-md-12 mt-5 usr-dash-tab-sec'>
              <div className='usr-dash-head'>Our suggestions</div>
              {/* <p className='usr-dash-p mt-2'>Suggesting a few course tracks by which you could attain the minimum points required to meet global average. </p> */}

              <div className='col-md-12 related-courses-mainbox'>
                {this.state.careerData.slice(0, 3).map((data, i) => {
                  return (
                    <div className="related-courses-box" onClick={() => this.coursePopup(data)}>
                      <div className='related-courses-box-zoom'>
                        <a className="related-courses-box-a">
                          <img alt="" className="related-courses-img" src={data.imageUrl} />
                        </a>
                      </div>
                      <a className="related-courses-box-content">
                        <p className='m-0' style={{ fontSize: "12px" }}><b>Institute</b> : {data.universityName}</p>
                        <p className="related-courses-box-text" title={data.CourseName}>{data.CourseName.substring(0, 100)} </p>
                        <p className='m-0' style={{ fontSize: "12px" }}>
                          <b>ivanooograde</b> : {data.CourseFields[0].CourseScore}
                        </p>
                        {/* <p className='stanford-university'>
                          {data.universityName}
                        </p> */}
                      </a>
                      <p className='related-courses-box-bottom'>
                        {data.courseDescription}
                      </p>
                    </div>
                  )
                })}
              </div>
              <div className='col-md-12 related-courses-mainbox'>
                {this.state.careerData1.length > 0 ?
                  <div className='usr-dash-subhead mb-2'>Recommendation for Skill : {this.state.skillData[0].skillName}</div>
                  : ""}
                {this.state.careerData1.slice(0, 3).map((data, i) => {
                  return (
                    <div className="related-courses-box" onClick={() => this.coursePopup(data)}>
                      <div className='related-courses-box-zoom'>
                        <a className="related-courses-box-a">
                          <img alt="" className="related-courses-img" src={data.imageUrl} />
                        </a>
                      </div>
                      <a className="related-courses-box-content">
                        <p className='m-0' style={{ fontSize: "12px" }}><b>Institute</b> : {data.universityName}</p>
                        <p className="related-courses-box-text" title={data.CourseName}>{data.CourseName.substring(0, 100)} </p>
                        <p className='m-0' style={{ fontSize: "12px" }}>
                          <b>ivanooograde</b> : {data.CourseFields[0].CourseScore}
                        </p>
                        {/* <p className='stanford-university'>
                          {data.universityName}
                        </p> */}
                      </a>
                      <p className='related-courses-box-bottom'>
                        {data.courseDescription}
                      </p>
                    </div>
                  )
                })}
              </div>
              <div className='col-md-12 related-courses-mainbox'>
                {this.state.careerData2.length > 0 ?
                  <div className='usr-dash-subhead mb-2'>Recommendation for Skill : {this.state.skillData[1].skillName}</div>
                  : ""}
                {this.state.careerData2.slice(0, 3).map((data, i) => {
                  return (
                    <div className="related-courses-box" onClick={() => this.coursePopup(data)}>
                      <div className='related-courses-box-zoom'>
                        <a className="related-courses-box-a">
                          <img alt="" className="related-courses-img" src={data.imageUrl} />
                        </a>
                      </div>
                      <a className="related-courses-box-content">
                        <p className='m-0' style={{ fontSize: "12px" }}><b>Institute</b> : {data.universityName}</p>
                        <p className="related-courses-box-text" title={data.CourseName}>{data.CourseName.substring(0, 100)} </p>
                        <p className='m-0' style={{ fontSize: "12px" }}>
                          <b>ivanooograde</b> : {data.CourseFields[0].CourseScore}
                        </p>
                        {/* <p className='stanford-university'>
                          {data.universityName}
                        </p> */}
                      </a>
                      <p className='related-courses-box-bottom'>
                        {data.courseDescription}
                      </p>
                    </div>
                  )
                })}
              </div>
              <div className='col-md-12 related-courses-mainbox'>
                {this.state.careerData3.length > 0 ?
                  <div className='usr-dash-subhead mb-2'>Recommendation for Skill : {this.state.skillData[2].skillName}</div>
                  : ""}
                {this.state.careerData3.slice(0, 3).map((data, i) => {
                  return (
                    <div className="related-courses-box" onClick={() => this.coursePopup(data)}>
                      <div className='related-courses-box-zoom'>
                        <a className="related-courses-box-a">
                          <img alt="" className="related-courses-img" src={data.imageUrl} />
                        </a>
                      </div>
                      <a className="related-courses-box-content">
                        <p className='m-0' style={{ fontSize: "12px" }}><b>Institute</b> : {data.universityName}</p>
                        <p className="related-courses-box-text" title={data.CourseName}>{data.CourseName.substring(0, 100)} </p>
                        <p className='m-0' style={{ fontSize: "12px" }}>
                          <b>ivanooograde</b> : {data.CourseFields[0].CourseScore}
                        </p>
                        {/* <p className='stanford-university'>
                          {data.universityName}
                        </p> */}
                      </a>
                      <p className='related-courses-box-bottom'>
                        {data.courseDescription}
                      </p>
                    </div>
                  )
                })}
              </div>
              {/* <Tabs className="react-tabs-main">
                <TabList>
                  <Tab>Marketing </Tab>
                </TabList>

                <TabPanel>
                  

                  <div className='col-md-12 related-courses-mainbox'>
                    {this.state.careerData.slice(0, 3).map((data, i) => {
                      return (
                        <div className="related-courses-box" onClick={() => this.coursePopup(data)}>
                          <div className='related-courses-box-zoom'>
                            <a className="related-courses-box-a">
                              <img alt="" className="related-courses-img" src={data.imageUrl} />
                            </a>
                          </div>
                          <a>
                            <p className="related-courses-box-text" title={data.CourseName}>{data.CourseName.substring(0, 35)} </p>
                            <p className='stanford-university'>
                              {data.universityName}
                            </p>
                            <p className='related-courses-box-bottom'>
                              The online Digital Marketing course based in Dubai is an up-to-date course inclusive of latest tools, platforms,
                            </p>
                          </a>
                        </div>
                      )
                    })}
                  </div>
                </TabPanel>
              </Tabs> */}
            </div>
          </div>
        </div>


        <div className="modal fade course-popup-wrapper" id="coursePopup" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => this.closePopup()}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body row">
                <div className='popup-course-left col-md-9'>
                  <div className="popup-course-left-box">
                    <div className='popup-course-left-top row'>
                      <div className="popup-course-left-topImg col-md-3 col-lg-2">
                        <img alt="" className="popup-course-left-img img-fluid" src={this.state.imageUrl} />
                      </div>
                      <div className='popup-course-left-topCont col-md-9 col-lg-10'>
                        {/* <p className='stanford-university'>
                          Institute : {this.state.universityName}
                        </p> */}
                        <p style={{ fontSize: "16px" }}><b>Institute</b> : {this.state.universityName}</p>
                        <p className="popup-course-left-top-head"> {this.state.CourseName} </p>
                        <p className='popup-course-left-bottom-p'>
                          <b>ivanooograde</b> : {this.state.ivanooograde}

                        </p>
                        <p className='popup-course-left-bottom-p'>

                          <b>Course Description</b> : {this.state.courseDescription}
                        </p>
                      </div>
                      {/* <div className='popup-course-left-topCont col-md-9 col-lg-10' style={{ marginLeft: "135px", marginTop: "-3px" }}>
                        <StarRatings
                          rating={this.state.Courserating}
                          starRatedColor="blue"
                          numberOfStars={5}
                          name='rating'
                          starDimension='30px'
                        />
                      </div> */}

                    </div>

                    <div className='popup-course-left-bottom col-md-122'>
                      <div className='popup-course-icon'>
                        {/* <i className='fa fa-bookmark-o' id="activeCourse"></i> */}
                        {/* <i className='fa fa-bookmark'></i> */}
                      </div>
                      {/* <div className='popup-course-btn'>
                        <i className='fa fa-list-alt'></i> Add to list
                      </div> */}
                      {/* <div className='popup-course-btn'>
                        <a href={"/course-details/id=" + this.state.key}><i className='fa fa-eye'></i> Quick View</a>
                      </div> */}
                    </div>
                  </div>
                </div>
                <div className="popup-course-right col-md-3">
                  <div className='popup-course-right-list'>
                    {/* <div className='popup-course-ricon'><i className='fa fa-language'></i></div> */}
                    <div><b>Accreditation :</b> {this.state.accrediation}</div>
                  </div>
                  <div className='popup-course-right-list'>
                    <div><b>Course Fee :</b> {this.state.price}</div>
                    {/* <div className='popup-course-ricon'><i className='fa fa-money'></i></div>
                    <div className='popup-course-rText'>{this.state.price}</div> */}
                  </div>
                  <div className='popup-course-right-list'>
                    <div><b>Course Duration :</b> {this.state.duration}</div>
                    {/* <div className='popup-course-ricon'><i className='fa fa-money'></i></div>
                    <div className='popup-course-rText'>{this.state.price}</div> */}
                  </div>
                  <div className='popup-course-right-list'>
                    <div><b>Mode of learning :</b> {this.state.Modeoflearning}</div>
                    {/* <div className='popup-course-ricon'><i className="fa fa-cloud"></i></div>
                    <div className='popup-course-rText'>{this.state.Modeoflearning}</div> */}
                  </div>
                  <div className='popup-course-right-list' style={{ display: "none" }}>
                    <div><b>Course Of Outcome</b> </div>
                    {this.state.outcome.QuickUpskills == "True" ?
                      <div>Quick Upskilling</div>
                      : ""
                    }
                    {this.state.outcome.Jobs == "True" ?
                      <div>Job Assistance</div>
                      : ""
                    }
                    {this.state.outcome.Certificates == "True" ?
                      <div>Certificates</div>
                      : ""
                    }
                    {/* <div className='popup-course-ricon'><i className="fa fa-calendar"></i></div>
                    <div className='popup-course-rText'>{this.state.duration}</div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/ivano/dashboard.jsx